export default "__VITE_ASSET__PNzfsCZr__"